import React, { useEffect, useState } from "react";
import NavBar from "../components/navBar/NavBar";
import FooterComponent from "../components/footer/FooterComponent";
import about1 from "../assets/images/about.jpg";
import about2 from "../assets/images/about2.webp";
import "../styles/about.css";

const About = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFadeIn(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="about-page">
      <NavBar />
      <div className={`about-content ${fadeIn ? "fade-in" : ""}`} style={{padding:"0px 16px"}}>
        <h1 className="about-title">About Us</h1>

        <p className="about-text">
          We are passionate about teaching young minds and dedicated to building
          strong foundations for their learning journeys. Our approach focuses
          on unlocking reading skills through sounds and phonics, ensuring a
          comprehensive development of their overall reading abilities. We
          believe in nurturing a love for reading that will last a lifetime.
        </p>

        <img src={about1} alt="About 1" className="about-image" />

        <p className="about-subtitle">Why Phonics is Key to Your Child's Reading Success</p>

        <p className="about-text">
          We're thrilled you're exploring our phonics-based learning platform.
          You might be wondering, why is phonics so important for young learners?
        </p>

        <p className="about-text">
          Phonics is the fundamental building block of reading. It teaches children
          the crucial connection between sounds and letters. Imagine giving your child
          a secret code to unlock thousands of words! By understanding these
          sound-letter relationships, children can decode new words independently.
        </p>

        <p className="about-highlight">
          Build reading fluency: <span className="about-subtext">
            As they become more confident decoders, their reading becomes smoother and faster.
          </span>
        </p>

        <p className="about-highlight">
          Improve spelling: <span className="about-subtext">
            Knowing how sounds relate to letters helps them write words accurately.
          </span>
        </p>

        <p className="about-highlight">
          Boost reading comprehension: <span className="about-subtext">
            When less effort is spent on decoding, more brainpower can be used to understand the text.
          </span>
        </p>

        <img src={about2} alt="About 2" className="about-image" />

        <p className="about-text">
          At our core, we believe every child deserves to experience the joy of reading.
          We meticulously design our lessons to be engaging, effective, and tailored
          to how young minds learn best. We're committed to nurturing your child's
          journey from their very first sound to becoming a confident, lifelong reader.
        </p>
      </div>
      <FooterComponent />
    </div>
  );
};

export default About;
